// accept only alphabet and some special characters like -,_,',. upto 20 length
export const nameValidation = (name) => {
  let reg = /^[a-zA-Z\-_.'\s]{1,20}$/;
  return reg.test(name);
};

export const nameRegisterValidation = (name) => {
  let reg = /^[a-zA-Z\-_.'\s]{1,20}$/;
  return reg.test(name);
};

export const CompanyNameValidation = (name) => {
  let reg = /^[A-Za-z0-9 .',_-]{1,100}$/;
  return reg.test(name);
};

export const CompanyFieldValidation = (name) => {
  let reg = /^[A-Za-z &-]{1,25}$/;
  return reg.test(name);
};

export const CompanyPincodeValidation = (name) => {
  let reg = /^(\d{4}|\d{6})$/;
  return reg.test(name);
};

export const emailValidation = (email) => {
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return reg.test(email);
};

export const CINValidation = (cin) => {
  let reg = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{1,21}$/i;
  return reg.test(cin);
};
export const DINValidation = (din) => {
  let reg = /^[A-Z0-9]{1,8}$/i;
  return reg.test(din);
};
export const GSTINValidation = (gst) => {
  let reg = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{1,16}$/i;
  return reg.test(gst);
};
export const UaadharValidation = (udhaar) => {
  let reg = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{1,12}$/i;
  return reg.test(udhaar);
};
export const FSSAIValidation = (fssai) => {
  let reg = /^[A-Z0-9]{1,14}$/i;
  return reg.test(fssai);
};

export const generateCaptcha = () => {
  const captchaAlphabets =
    "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz0123456789";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha +=
      captchaAlphabets[Math.floor(Math.random() * captchaAlphabets.length)];
  }
  return captcha;
};
